import React from "react";
import {withStyles} from "@material-ui/core";
import Grid from '@material-ui/core/Grid';

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from "@material-ui/core/Tooltip";


import pricingStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/pricingStyle.js";
import intl from 'react-intl-universal';



function isEmpty(object) {
	if (object === null || object === undefined) {
		return true;
	}

	return false;
}

class UserInvitationItem extends React.Component {


	constructor(props, context) {
		super(props, context);
	}

	render() {
		const {classes} = this.props;
		const data = this.props.data;


		return (
			<GridItem xs={12} sm={12} md={12} lg={12}>
				<Card product
					style={{padding: '6px', marginTop: '-24px'}}>
				<GridContainer>
					<GridItem xs={3} sm={1} md={1} lg={1}>
						<div style={{
							width: '50px', height: '50px',
							backgroundColor: '#e91e63',
							borderRadius: '100px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}>
							<b style={{color: '#fff'}}>{data.userName}</b>
						</div>
					</GridItem>
					<GridItem xs={9} sm={7} md={7} lg={7} style={{
						display: 'flex',
						// justifyContent: 'center',
						alignItems: 'center'
					}}>
						<b style={{color: '#4A6CE8'}}>
						{data.userEmail}
						</b>
					</GridItem>
					<GridItem xs={7} sm={4} md={4} lg={4} style={{
						display: 'flex',
						// justifyContent: 'end',
						alignItems: 'center'
					}}>
						<b>
							{data.userTime}&nbsp;&nbsp;{intl.get('join')}
						</b>
					</GridItem>
					{/*<GridItem xs={5} sm={3} md={3} lg={3} style={{*/}
					{/*	display: 'flex',*/}
					{/*	justifyContent: 'center',*/}
					{/*	alignItems: 'center'*/}
					{/*}}>*/}
					{/*	{*/}
					{/*		data.userCanExchange ?*/}
					{/*			<div*/}
					{/*			>*/}
					{/*				<b style={{color: '#5ECCAE'}}>{intl.get('convertible')}</b>*/}
					{/*			</div>*/}
					{/*			:*/}
					{/*			<div*/}
					{/*				 style={{display: 'flex',*/}
					{/*					 alignItems: 'center'}}*/}
					{/*			>*/}
					{/*				<b style={{color: '#4A6CE8'}}>{intl.get('not_convertible')}</b>*/}
					{/*				<Tooltip*/}
					{/*					id="tooltip-top"*/}
					{/*					title={intl.get('convertible_tips')}*/}
					{/*					placement="top"*/}
					{/*					classes={{ tooltip: classes.tooltip }}*/}
					{/*				>*/}
					{/*					<HelpOutlineIcon style={{marginLeft: '12px', color: '#4A6CE8'}}/>*/}
					{/*				</Tooltip>*/}
					{/*			</div>*/}
					{/*	}*/}
					{/*</GridItem>*/}

				</GridContainer>
				</Card>
			</GridItem>
		);
	}
}

export default withStyles(pricingStyle)(UserInvitationItem)